import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=440ae19b&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./order.scss?vue&type=style&index=0&id=440ae19b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ae19b",
  null
  
)

export default component.exports